import {I18n} from "i18n-js";
import {TranslateOptions} from "i18n-js/src/typing";
import {Locale, UserSettingsApi} from "api/UserSettingsApi";
import {UserState, useUserState} from "store/user-store";
import {StringKey} from "./keys";

const NONE_LOCALE = "none"
// regex for {key} placeholders
const STRING_PLACEHOLDER = /\{([^}]+)\}/gm;

const i18n = new I18n();

i18n.missingBehavior = "custom-missing";
i18n.enableFallback = true;
i18n.defaultLocale = "en";

i18n.missingTranslation.register("custom-missing", (i18nUsed, scope) => {
    const scopeStr = Array.isArray(scope) ? scope.join(".") : scope;
    if(isTranslateMode()) {
        return `{{${scopeStr}}}`;
    }
    return `Err: ${scopeStr}`;
});

i18n.missingTranslation.register("interpolated-missing", (i18nUsed, scope) => {
    const scopeStr = Array.isArray(scope) ? scope.join(".") : scope;
    if(isTranslateMode()) {
        return `{{${scopeStr}}}`;
    }
    // TODO: Handle company prefixes
    return `{${scopeStr} (missing tl.)}`;
});

i18n.missingTranslation.register("none", (i18nUsed, scope) => {
    return "";
});

// load current locale lang bundle
function loadTranslations() {
    if(isTranslateMode()) {
        console.log("Translate mode enabled, skipping loading translations")
        return;
    }

    const locale = i18n.locale as Locale;
    UserSettingsApi.getLanguageBundle(locale).then((response) => {
        if (response.data) {
            const localeDict = {[locale]: response.data}
            i18n.store(localeDict);
            console.log("Loaded locale bundle", locale)
        }
    });
}

function setupLocale(state?: UserState) {
    const usedState = state ?? useUserState.getState();
    i18n.locale = usedState.getLanguage()
    console.log("Locale set to", i18n.locale)

    loadTranslations()
}

// setup locale on app load, or update it when user changes
if (useUserState.getState().isCurrentUserLoaded) {
    setupLocale()
}

useUserState.subscribe((state) => {
    console.log("User state changed, updating locale...")
    setupLocale(state)
});


export function isTranslateMode() {
    return i18n.locale === NONE_LOCALE;
}

/*
    Translates language key to current locale
 */
export function T(key: Readonly<StringKey>, options?: TranslateOptions) {
    return i18n.t(key, options);
}

/*
    * Interpolates(translates) string with placeholders
 */
export function I(message: string) {
    const matches = message.match(STRING_PLACEHOLDER);

    if (!matches) {
        return message;
    }

    while (matches.length) {
        let value: string;
        const placeholder = matches.shift() as string;
        const name = placeholder.replace(STRING_PLACEHOLDER, "$1");

        const translatedPlaceholder = i18n.t(name, {missingBehavior: "interpolated-missing"});
        value = translatedPlaceholder.toString().replace(/\$/gm, "_#$#_");

        const regex = new RegExp(
            placeholder.replace(/\{/gm, "\\{").replace(/}/gm, "\\}"),
            "g",
        );

        message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
}




